/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guest_Book_SubmittingInputs */

const en_guest_book_submitting = /** @type {(inputs: Guest_Book_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending…`)
};

const pl_guest_book_submitting = /** @type {(inputs: Guest_Book_SubmittingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wysyłam…`)
};

/**
* | output |
* | --- |
* | "Sending…" |
*
* @param {Guest_Book_SubmittingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const guest_book_submitting = /** @type {((inputs?: Guest_Book_SubmittingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guest_Book_SubmittingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_guest_book_submitting(inputs)
	return en_guest_book_submitting(inputs)
});